/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_CrumbInputs */

const en_auth_signup_crumb = /** @type {(inputs: Auth_Signup_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signup`)
};

/**
* | output |
* | --- |
* | "Signup" |
*
* @param {Auth_Signup_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_crumb = /** @type {((inputs?: Auth_Signup_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_signup_crumb(inputs)
});